<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="12">
        <component-header
          title="Edit FAQ"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Faqs' })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="12" md="12">
        <b-card>
          <b-row class="font-md form-row" v-if="$userRole === 'Tenant'">
            <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
              <span class="form-label">Scope</span>
            </b-col>
            <b-col cols="12" sm="12" md="8" class="mb-3 mb-md-0">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="formData.scope"
                  :options="scopeOptions"
                  placeholder="Scope"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md form-row">
            <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
              <span class="form-label">Category</span>
            </b-col>
            <b-col cols="12" sm="12" md="8" class="mb-3 mb-md-0">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="formData.category"
                  :options="categoryOptions"
                  placeholder="Category Type"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md form-row">
            <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
              <span class="form-label">Topic</span>
            </b-col>
            <b-col cols="12" sm="12" md="8" class="mb-3 mb-md-0">
              <div class="form-group">
                <input class="form-control" v-model="formData.Topic" />
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md form-row">
            <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
              <span class="form-label">Description</span>
            </b-col>
            <b-col cols="12" sm="12" md="8" class="mb-3 mb-md-0">
              <div class="form-group">
                <input class="form-control" v-model="formData.Description" />
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md form-row">
            <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
              <span class="form-label">Media Type</span>
            </b-col>
            <b-col cols="12" sm="12" md="8" class="mb-3 mb-md-0">
              <div class="form-group">
                <eb-select
                  id="type"
                  v-model="faqData.mediaType"
                  :selected="faqData.mediaType"
                  :options="mediaOptions"
                  @select="onSelect"
                  placeholder="Media Type"
                ></eb-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md form-row">
            <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
              <span class="form-label">Media Content</span>
            </b-col>
            <b-col cols="12" sm="12" md="8" class="mb-3 mb-md-0">
              <div class="mb-3">
                <eb-button
                  classic="mr-1 btn-primary"
                  text="Download Content"
                  @click="downloadFile"
                ></eb-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md form-row">
            <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
              <span class="form-label">Update Media</span>
            </b-col>
            <b-col cols="12" sm="12" md="8" class="mb-3 mb-md-0">
              <div class="form-group">
                <b-form-file
                  @change="changemedia"
                  :state="Boolean()"
                  :accept="uploadFileType"
                  placeholder="Update Media Here..."
                  drop-placeholder="Drop Media here..."
                ></b-form-file>
              </div>
            </b-col>
            <b-col cols="12" sm="12" md="1" v-if="showLoader" class="mb-3 mb-md-0">
              <div class="spinner-border text-primary" role="status"></div>
            </b-col>
          </b-row>
          <span v-if="invalidFile" class="validate-error"
              >Invalid File format</span>
            <div class="text-center mt-3 mb-3">
              <eb-button
                class="btn mr-4"
                classic="mr-1 btn-primary"
                text="Update"
                :disabled="invalidFile || showLoader"
                @click.prevent="handleSubmit"
              ></eb-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import { mapState } from "vuex";
import currentUser from "@/mixins/currentUser";

export default {
  name: "editfaq",
  mixins: [currentUser],
  components: {
    ebButton,
    ebSelect,
    ComponentHeader,
  },
  data: () => {
    return {
      show: true,
      mediaOptions: ["VIDEO", "IMAGE", "DOCUMENT"],
      categoryOptions: ["Order", "Payment"],
      scopeOptions: ["PARTNER", "CUSTOMER"],
      mediaType: "",
      selected: "",
      photo: "",
      scope: "",
      id: "",
      category: "",
      topic: "",
      description: "",
      invalidFile: false,
      showLoader: false,
      formData: {
        scope: "",
        category: "",
        Topic: "",
        Description: "",
        mediaType: "",
      },
    };
  },
  // props: {
  //   faqData: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  computed: {
    ...mapState({
      faqData: (state) => state.faq.faqData,
    }),
    uploadFileType() {
      if (this.faqData.mediaType == "IMAGE") return "image/*";
      if (this.faqData.mediaType == "VIDEO") return "video/*";
      return "text/*,application/*";
    },
  },
  watch: {
    faqData: {
      handler(val) {
        if (val && Object.keys(val).length) {
          this.formData = {
            scope: val.scope || "",
            category: val.category || "",
            Topic: val.Topic || "",
            Description: val.Description || "",
            mediaType: val.mediaType || "",
          };
          this.photo = val.mediaContent || "";
        }
      },
      immediate: true,
    },
    "formData.mediaType"(newval, oldval) {
      if (newval !== oldval) {
        if (this.photo !== "") this.invalidFile = true;
        this.photo = "";
      }
    },
  },
  methods: {
   downloadFile() {
  let fileUrl = this.faqData.mediaContent;

  if (!fileUrl) {
    this.$swal({
      title: "Error",
      text: "No media found to display!",
      type: "error",
    });
    return;
  }

  if (!fileUrl.startsWith("http")) {
    fileUrl = `https://dev.app.nipige.com${fileUrl}`; 
  }
  const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(fileUrl);
  const isDoc = /\.(pdf|doc|docx|ppt|pptx)$/i.test(fileUrl);

  if (isImage) {
    const newTab = window.open("", "_blank");
    newTab.document.write(`
      <html>
        <head><title>Image Preview</title></head>
        <body style="margin:0;display:flex;justify-content:center;align-items:center;background:#000;">
          <img src="${fileUrl}" style="max-width:100%;max-height:100vh;"/>
        </body>
      </html>
    `);
  } else if (isDoc) {
    const viewUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
    window.open(viewUrl, "_blank");
  } else {
    window.open(fileUrl, "_blank");
  }
},
    async uploadFile(file) {
      this.$toasted.info("Uploading...");
      this.showLoader = true;
      if (this.faqData.mediaType !== "IMAGE") {
        await this.$store
          .dispatch("inventory/uploadVideoToStorage", file)
          .then((res) => {
            this.photo = res.data.fileUrl;
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              text: "File Upload failed! please try again.",
            });
          });
        this.$toasted.success("Upload Complete");
      } else {
        let dataobj = {
          image: file,
          key: (
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
          ).toLowerCase(),
          isPublic: true,
          replaceExisting: true,
          basePath: "faq",
        };
        await this.$store
          .dispatch("inventory/uploadImageToStorage", dataobj)
          .then((res) => {
            this.photo = res.data.fileUrl;
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              text: "File Upload failed! please try again.",
            });
          });
        this.$toasted.success("Upload Complete");
      }
      this.showLoader = false;
    },
    changemedia(e) {
      if (
        this.faqData.mediaType == "IMAGE" &&
        !e.target.files[0].type.match("image.*")
      ) {
        this.invalidFile = true;
        e.target.value = "";
        return;
      }
      if (
        this.faqData.mediaType == "VIDEO" &&
        !e.target.files[0].type.match("video.*")
      ) {
        this.invalidFile = true;
        e.target.value = "";
        return;
      }
      if (
        this.faqData.mediaType == "DOCUMENT" &&
        !(
          e.target.files[0].type.match("application.*") ||
          e.target.files[0].type.match("text.*")
        )
      ) {
        this.invalidFile = true;
        e.target.value = "";
        return;
      }
      this.invalidFile = false;
      if (this.faqData.mediaType !== "IMAGE") {
        if (e.target.files.length != 0) {
          const formData = new FormData();
          formData.append("file", e.target.files[0]);
          formData.append("isPublic", "true");
          formData.append("replaceExisting", "true");
          formData.append("basePath", "faq");
          formData.append(
            "key",
            (
              Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
            ).toLowerCase()
          );
          this.uploadFile(formData);
        }
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = () => {
          this.uploadFile(reader.result);
          //this.$emit("readIMG", this.img);
        };
        reader.onerror = (err) => {
          console.error("reader : ", err);
        };
      }
    },
    async handleSubmit() {
      let dataObj;
      if (this.$userRole === "Tenant") {
        dataObj = {
          id: this.faqData._id + "/" + this.faqData.item_id,
          data: {
            tenant: this.$store.getters["auth/getUserID"],
            category: this.faqData.category,
            scope: this.faqData.scope,
            item: {
              topic: this.faqData.Topic,
              description: this.faqData.Description,
              media: {
                mediaType: this.faqData.mediaType,
                mediaContent: this.photo,
              },
            },
          },
        };
      } else {
        dataObj = {
          id: this.faqData._id + "/" + this.faqData.item_id,
          data: {
            category: this.faqData.category,
            scope: "TENANT",
            item: {
              topic: this.faqData.Topic,
              description: this.faqData.Description,
              media: {
                mediaType: this.faqData.mediaType,
                mediaContent: this.photo,
              },
            },
          },
        };
      }
      await this.$store.dispatch("faq/updateFaq", dataObj).then(() => {
        this.$swal({
          title: "Success",
          text: "Faq updated successfully!!",
          type: "success",
        });
      });
      this.$router.push({ name: "Faqs" });
    },
  },
};
</script>
<style scoped>
.form-row {
    margin-bottom: 1rem;
}

.form-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
}

.validate-error {
    display: block;
    color: red;
    font-size: 12px;
    margin-top: 5px;
}

.fa-plus {
    border-top-right-radius: 10px;
    border-top-left-radius: 17px;
    border-bottom-left-radius: 17px;
    background-color: #f0f3f5;
}

@media (max-width: 767.98px) {
    .form-label {
        margin-bottom: 0.25rem;
        font-size: 0.9rem;
    }
}
</style>
